exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.breaks-list[data-v-12ca1e7e] {\n}\n", ""]);

// exports
